import React from "react";

interface Props {
  finishes: any;
  currentFinishes: any;
  setCurrentFinishes: (value: any) => void;
}

const Finishes: React.FC<Props> = ({ finishes, currentFinishes, setCurrentFinishes }) => {
  return (
    <div className="bottombar-finishes">
      <div className='bottombar-finishes-title'>{finishes.name}</div>
      <div className='bottombar-finishes-options'>
        {
          finishes?.options?.map( (option: any, index: number) => 
            <div key={option.id} className="bottombar-finishes-option" onClick={() => {setCurrentFinishes(option)}}>
              <img className={`bottombar-finishes-option-img ${(currentFinishes?.id === option.id) ? 'selected' : ''}`} src={option.image.default || option.image} draggable={false} alt=''/>
              <div className='bottombar-finishes-option-title'>{option.name}</div>
            </div>
          )
        }
      </div>
    </div>
  );
};

export default Finishes;